import { Typography } from '@branch-messenger/willow-ui'

export const GenericError = () => (
  <Typography $size="sm">
    An error occurred. Please try again or contact Branch support{' '}
    <a
      target="_blank"
      href="https://support.branchapp.com/hc/en-us/requests/new"
      rel="noreferrer"
    >
      here
    </a>
  </Typography>
)
